// extracted by mini-css-extract-plugin
export default {"container":"Header_container__G8AIc","heading":"Header_heading__PPXzG","right":"Header_right__2UOow"};